(function () {
  'use strict';

  // ===== SIDEBAR TOGGLE =====
  var toggleBtn = document.getElementById('sd-filter-toggle');
  var collectionEl = document.getElementById('Collection');
  var toggleLabel = toggleBtn ? toggleBtn.querySelector('.sd-toggle-label') : null;

  // Backdrop dla mobile
  var backdrop = document.createElement('div');
  backdrop.className = 'sd-mobile-backdrop';
  if (collectionEl) collectionEl.appendChild(backdrop);

  function isMobile() { return window.innerWidth <= 768; }

  function openSidebar() {
    collectionEl.classList.add('sd-sidebar-open');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    if (isMobile()) document.body.style.overflow = 'hidden';
  }

  function closeSidebar() {
    collectionEl.classList.remove('sd-sidebar-open');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (toggleBtn && collectionEl) {
    toggleBtn.classList.add('btn-filter');
    toggleBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      collectionEl.classList.contains('sd-sidebar-open') ? closeSidebar() : openSidebar();
    });
  }

  // Zamknij przez backdrop (mobile)
  backdrop.addEventListener('click', closeSidebar);

  // Zamknij przez X (mobile)
  var mobileCloseBtn = document.getElementById('sd-mobile-close');
  if (mobileCloseBtn) mobileCloseBtn.addEventListener('click', closeSidebar);

  // ===== COLLAPSIBLE SECTIONS =====
  document.querySelectorAll('.sd-section-header').forEach(function (header) {
    header.addEventListener('click', function () {
      var section = this.closest('.sd-filter-section');
      var isOpen = section.classList.contains('sd-open');
      section.classList.toggle('sd-open', !isOpen);
      this.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  // ===== SEARCH WITHIN FILTER =====
  document.querySelectorAll('.sd-filter-search').forEach(function (input) {
    input.addEventListener('input', function () {
      var query = this.value.toLowerCase().trim();
      var items = this.closest('.sd-section-body').querySelectorAll('.sd-filter-item');
      items.forEach(function (item) {
        var text = item.querySelector('.sd-checkbox-text');
        if (!text) return;
        item.style.display = text.textContent.toLowerCase().indexOf(query) > -1 ? '' : 'none';
      });
    });
  });

  // ===== SHOW MORE / LESS =====
  document.querySelectorAll('.sd-show-more').forEach(function (btn) {
    var section = btn.closest('.sd-section-body');
    var extraItems = Array.prototype.slice.call(section.querySelectorAll('.sd-filter-item.sd-hidden'));

    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('data-expanded') === 'true';
      if (expanded) {
        extraItems.forEach(function (item) { item.classList.add('sd-hidden'); });
        btn.textContent = 'Pokaż więcej';
        btn.setAttribute('data-expanded', 'false');
      } else {
        extraItems.forEach(function (item) { item.classList.remove('sd-hidden'); });
        btn.textContent = 'Pokaż mniej';
        btn.setAttribute('data-expanded', 'true');
      }
    });
  });

  // ===== COLOR SWATCH OVERFLOW (+N) =====
  document.querySelectorAll('.sd-color-list').forEach(function (list) {
    var limit = 7;
    var items = list.querySelectorAll('.sd-filter-item');
    if (items.length <= limit) return;

    var overflow = items.length - limit;
    for (var i = limit; i < items.length; i++) {
      items[i].classList.add('sd-color-overflow');
    }

    var li = document.createElement('li');
    li.className = 'sd-filter-item';
    var btn = document.createElement('button');
    btn.className = 'sd-color-more-btn';
    btn.type = 'button';
    btn.textContent = '+' + overflow;
    li.appendChild(btn);
    list.appendChild(li);

    btn.addEventListener('click', function () {
      list.querySelectorAll('.sd-color-overflow').forEach(function (item) {
        item.classList.remove('sd-color-overflow');
      });
      li.style.display = 'none';
    });
  });

  // ===== FORM SUBMIT =====
  var filterForm = document.getElementById('sd-filter-form');
  if (filterForm) {
    filterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      document.body.style.overflow = '';

      var params = new URLSearchParams();

      var sortInput = this.querySelector('input[name="sort_by"]');
      if (sortInput && sortInput.value) params.set('sort_by', sortInput.value);

      this.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) {
        params.append(cb.name, cb.value);
      });

      var priceGteEl = document.getElementById('sd-price-gte');
      var priceLteEl = document.getElementById('sd-price-lte');
      var sliderW = document.querySelector('.sd-slider-wrap');
      if (sliderW) {
        var rMin = parseFloat(sliderW.getAttribute('data-min'));
        var rMax = parseFloat(sliderW.getAttribute('data-max'));
        if (priceGteEl && priceGteEl.value !== '' && parseFloat(priceGteEl.value) > rMin) {
          params.set('filter.v.price.gte', priceGteEl.value);
        }
        if (priceLteEl && priceLteEl.value !== '' && parseFloat(priceLteEl.value) < rMax) {
          params.set('filter.v.price.lte', priceLteEl.value);
        }
      }

      var base = this.action.split('?')[0];
      var qs = params.toString();
      window.location.href = base + (qs ? '?' + qs : '');
    });
  }

  // ===== PRICE RANGE SLIDER =====
  var sliderWrap = document.querySelector('.sd-slider-wrap');
  if (sliderWrap) {
    var rangeMin = parseFloat(sliderWrap.getAttribute('data-min'));
    var rangeMax = parseFloat(sliderWrap.getAttribute('data-max'));
    var sliderMinEl = document.getElementById('sd-range-min');
    var sliderMaxEl = document.getElementById('sd-range-max');
    var inputMinEl = document.getElementById('sd-price-min-input');
    var inputMaxEl = document.getElementById('sd-price-max-input');
    var trackFill = document.getElementById('sd-track-fill');
    var priceDebounce = null;

    function updatePriceUI() {
      var minVal = parseFloat(sliderMinEl.value);
      var maxVal = parseFloat(sliderMaxEl.value);

      if (minVal >= maxVal) {
        if (this === sliderMinEl) {
          sliderMinEl.value = maxVal - 1;
          minVal = parseFloat(sliderMinEl.value);
        } else {
          sliderMaxEl.value = minVal + 1;
          maxVal = parseFloat(sliderMaxEl.value);
        }
      }

      inputMinEl.value = Math.round(minVal);
      inputMaxEl.value = Math.round(maxVal);

      if (trackFill) {
        var leftPct = ((minVal - rangeMin) / (rangeMax - rangeMin)) * 100;
        var rightPct = ((maxVal - rangeMin) / (rangeMax - rangeMin)) * 100;
        trackFill.style.left = leftPct + '%';
        trackFill.style.width = (rightPct - leftPct) + '%';
      }

      sliderMinEl.style.zIndex = (minVal > rangeMin + (rangeMax - rangeMin) * 0.9) ? 5 : 3;
    }

    var priceGteInput = document.getElementById('sd-price-gte');
    var priceLteInput = document.getElementById('sd-price-lte');

    function syncPriceHidden() {
      if (priceGteInput) priceGteInput.value = Math.round(parseFloat(sliderMinEl.value));
      if (priceLteInput) priceLteInput.value = Math.round(parseFloat(sliderMaxEl.value));
    }

    sliderMinEl.addEventListener('input', function () { updatePriceUI.call(this); syncPriceHidden(); });
    sliderMaxEl.addEventListener('input', function () { updatePriceUI.call(this); syncPriceHidden(); });

    inputMinEl.addEventListener('change', function () {
      var val = Math.min(Math.max(parseFloat(this.value) || rangeMin, rangeMin), rangeMax - 1);
      this.value = val;
      sliderMinEl.value = val;
      updatePriceUI.call(sliderMinEl);
      syncPriceHidden();
    });
    inputMaxEl.addEventListener('change', function () {
      var val = Math.min(Math.max(parseFloat(this.value) || rangeMax, rangeMin + 1), rangeMax);
      this.value = val;
      sliderMaxEl.value = val;
      updatePriceUI.call(sliderMaxEl);
      syncPriceHidden();
    });

    updatePriceUI.call(sliderMinEl);
  }

  // ===== SORT =====
  var sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // ===== GRID / LIST TOGGLE =====
  function replaceUrlParam(url, paramName, paramValue) {
    var pattern = new RegExp('(' + paramName + '=).*?(&|$)');
    var newUrl = url.replace(pattern, '$1' + paramValue + '$2');
    if (newUrl === url) {
      newUrl += (newUrl.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
    }
    return newUrl;
  }

  document.querySelectorAll('.view-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var view = this.getAttribute('data-view');
      try { localStorage.setItem('phoneo-collection-view', view); } catch(e) {}
      window.location = replaceUrlParam(document.URL, 'view', view);
    });
  });

  // Stare buttony (fallback)
  document.querySelectorAll('.change-view').forEach(function (btn) {
    btn.addEventListener('click', function () {
      window.location = replaceUrlParam(document.URL, 'view', this.getAttribute('data-view'));
    });
  });

})();
